import React, { useState, useEffect, useRef } from "react";
import Slider from 'react-slick';
import { InView } from 'react-intersection-observer';
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import IconArrowRight from "../../icons/slider-right-arrow.svg";
import IconArrowLeft from "../../icons/slider-left-arrow.svg";
import LazyLoad from 'react-lazyload';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick} 
        >next <IconArrowRight /></div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick} 
      ><IconArrowLeft /> prev</div>
    );
  }
  

export default function IndustrySegments(props) {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let slider1 = null;
    let slider2 = null;

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    }, []);

    const settings = {
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 0,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      };


  const { title, header, content, classes, segmentSliderItems } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <InView onChange={(inView) => setIsVisible(inView)} id={props.id}>
      <div className={`page-intro-section section-gap-small ${classes}`} >
        <div className="container">
          <div className="segment-content">
            <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
            <h2 className="h2">{header}</h2>
            {content}
          </div>
          <div className="segment-slider">
            <div className="segment-slider-inner">
                <div className="segment-image-slider">
                    <Slider
                        asNavFor={nav2}
                        ref={slider => (slider1 = slider)}
                        //infinite={true}
                        arrows={false}
                        swipe={false}
                        fade={true}
                        speed={1000}
                        cssEase={'linear'}
                        autoplaySpeed= {5000}
                        autoplay= {true}    
                        slidesToShow={1}>
                        {segmentSliderItems && segmentSliderItems.map((item, i) => {
                            return (
                                <div className="d-flex segment-slider-item" key={i}>
                                    <div className="segment-slider-image">
                                        <LazyLoad><img src={item.image} title={item.imagetitle} alt={item.imagealt} /></LazyLoad>
                                    </div>
                                    
                                </div>
                            );
                        })}
                        {segmentSliderItems && segmentSliderItems.map((item, i) => {
                            return (
                                <div className="d-flex segment-slider-item" key={i}>
                                    <div className="segment-slider-image">
                                      <LazyLoad><img src={item.image} title={item.imagetitle} alt={item.imagealt} /></LazyLoad>
                                    </div>
                                    
                                </div>
                            );
                        })}
                    </Slider>
                </div>
                <div className="segment-content-slider">
                    <Slider
                    asNavFor={nav1}
                    ref={slider => (slider2 = slider)}
                    arrows={true}
                    infinite={true}
                    slidesToShow={3}
                    slidesToScroll={1}
                    swipe={false}
                    focusOnSelect={true}
                    {...settings}>
                        {segmentSliderItems && segmentSliderItems.map((item, i) => {
                            return (
                                <div className="d-flex segment-slider-item" key={i}>
                                    
                                    <div className="segment-slider-content">
                                        <span className="segment-slider-item-count">0{(i + 1)}</span>
                                        <div><h3 className="h4">{item.header}</h3></div>
                                        <div><p >{item.content}</p></div>
                                    </div>
                                </div>
                            );
                        })}
                        {segmentSliderItems && segmentSliderItems.map((item, i) => {
                            return (
                                <div className="d-flex segment-slider-item" key={i}>
                                    
                                    <div className="segment-slider-content">
                                        <span className="segment-slider-item-count">0{(i + 1)}</span>
                                        <div><h3 className="h4"><HeaderAnim header={item.header} /></h3></div>
                                        <div><p >{item.content}</p></div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
                
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}

